import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SrResourceService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 2150 */
    public async getResource(params: SrResourceParams): Promise<SrResourceGet> { return (await this.datatask.Post(2150, params))[0]; }
    /** @datatask 2151 */
    public async saveResource(page: SrResourceGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2151, page))[0]; }
    /** @datatask 2148 */
    public async getResourceView(): Promise<SrResourceViewGet> { return (await this.datatask.Post(2148, {}))[0]; }
    /** @datatask 2149 */
    public getResourceViews(params: { sub_resource_id: string; show_deactivated_resources: string }): Promise<Item[]> { return this.datatask.Post(2149, params); }
}

export interface SrResourceParams { resource_id_belongto: string; resource_id: string; }
export interface SrResourceGet extends SrResourceParams {
    main_resource_id: string;
    resource_name: string;
    frr_id: string | number;
    special_prod_name_view: string;
    activeproduct: '0' | '1';
}
export interface SrResourceViewGet {
    main_resource_id: string;
    sub_resource_id: string;
    show_deactivated_resources: string;
    show_main_resource_id: string;
    filtervalue: string;
}
